import Hero from "../components/hero/Hero"
import Image1 from "../assets/img1.jpeg"
import AboutUs from "../components/about/AboutUs"
import Footer from "../components/footer/FooterSimcor"


function About (){
  return(
  <>
    <Hero
      cName="hero-mid"
      heroImg={Image1}
      title="QUIENES SOMOS"
      btnClass="hide"
    />
    <AboutUs/>
    <Footer/>
     
  </>   
  );
};


export default About;